import { render, staticRenderFns } from "./ChecklistItem.vue?vue&type=template&id=3144232f&"
import script from "./ChecklistItem.vue?vue&type=script&lang=js&"
export * from "./ChecklistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports